import React, {useCallback, useMemo, useState} from 'react';
import {classes, style} from './doppe-action-content-section-testimonials-list.st.css';
import {listViewCreateDataSource, useObservableCalculatedValue} from '@wix/devzai-utils-react';
import {DoppeActionContentSection} from '../../../client-server-common/types/doppe-action-content-section';
import {
    doppeListActionListItemCalculateItemButtons,
    doppeListActionListItemCalculateItemSections,
    doppeListActionSettingsFilterHiddenListItemsFromActionView
} from '../../../client-server-common';
import {
    DoppeActionTypeWidgetItemListCarousel
} from '../../../doppe-action-types/doppe-actions-common/doppe-action-type-widget-item-list/doppe-action-type-widget-item-list';
import {
    DoppeActionTypeTestimonialListViewItem
} from '../../../doppe-action-types/doppe-actions-common/doppe-action-type-list-view-item/doppe-action-type-testimonial-list-view-item/doppe-action-type-testimonial-list-view-item';
import {assertDefined} from '@wix/devzai-utils-common';
import {
    DoppeActionTypeTestimonialWidgetInner
} from '../../../doppe-action-types/doppe-action-type-testimonial/doppe-action-type-testimonial-widget/doppe-action-type-testimonial-widget';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';
import {
    doppeViewerActionContextOpenModal
} from '../../../doppe-sdk/doppe-viewer-action-context/doppe-viewer-action-context-utils';
import {DoppeViewerModalPanelLayout} from '../../doppe-viewer-modal-panel/doppe-viewer-modal-panel';


export const DoppeActionContentSectionTestimonialsList = React.memo(function DoppeActionContentSectionTestimonialsList(
    props: DoppeActionContentSectionTestimonialsList.Props
) {
    const {
        contentSection,
        actionContext
    } = props;

    const {
        layout,
        listDataItems
    } = contentSection;


    const testimonialsToShow = useMemo(() => {
            return doppeListActionSettingsFilterHiddenListItemsFromActionView(listDataItems)
        },
        [listDataItems]
    );

    const testimonialsListViewDataSource = useMemo(() => {
            return listViewCreateDataSource(testimonialsToShow, {
                idFunction: item => item.id
            })
        },
        [testimonialsToShow]
    );

    const [currentId, setCurrentId] = useState(testimonialsToShow[0].id)

    const currentTestimonial = useObservableCalculatedValue(useCallback(() => {
        return assertDefined(testimonialsToShow.find(item => item.id === currentId));
    }, [currentId, testimonialsToShow]));


    return <DoppeActionTypeWidgetItemListCarousel
        className={style(classes.root, {})}
        listClassName={style(classes.innerList, {})}
        layout={layout}
        onItemClick={testimonialItem => {
            setCurrentId(testimonialItem.id)

            doppeViewerActionContextOpenModal(
                actionContext,
                () => {
                    return {
                        render: () =>
                            <DoppeActionTypeTestimonialWidgetInner
                                actionSettings={{
                                    ...currentTestimonial.getValue(),
                                    ...doppeListActionListItemCalculateItemSections(contentSection.listItemTemplateSectionsSettings, currentTestimonial.getValue()),
                                    ...doppeListActionListItemCalculateItemButtons(contentSection.listItemTemplateCtaButtonsSettings, currentTestimonial.getValue())

                                }}
                                reportGoalAchieved={() => {}}
                                actionContext={actionContext}
                                noContentTopPadding={true}
                            />,
                        dependencies: [currentTestimonial]
                    }
                },
                {
                    mobileLayout: DoppeViewerModalPanelLayout.Inner,
                    desktopLayout: DoppeViewerModalPanelLayout.Inner,
                    showHeader: true
                }
            );
        }}
        renderItem={(dataItem, layout, index) => {
            return (
                <DoppeActionTypeTestimonialListViewItem
                    innerItemId={dataItem.id}
                    innerItemIndex={index}
                    listItemSettings={dataItem}
                    layout={layout}
                    itemShowRating={true}
                    isOneItem={testimonialsListViewDataSource.length === 1}
                    hideImageWhenPossible={false}
                    hideTitleWhenPossible={false}
                    hideDescriptionWhenPossible={false}
                />
            )
        }}
        dataSourceItems={testimonialsListViewDataSource}
    />
});


export namespace DoppeActionContentSectionTestimonialsList {

    export interface Props extends React.HTMLAttributes<any> {
        contentSection: DoppeActionContentSection.TestimonialsSettings;
        actionContext: IDoppeViewerActionContext;
    }
}
